import { render, staticRenderFns } from "./ReportInstructivoEmbarqueAereo.vue?vue&type=template&id=6496f488&"
import script from "./ReportInstructivoEmbarqueAereo.vue?vue&type=script&lang=js&"
export * from "./ReportInstructivoEmbarqueAereo.vue?vue&type=script&lang=js&"
import style0 from "./ReportInstructivoEmbarqueAereo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports